import { DemeterMarket, DemeterTableDefinitionType } from '../../../../Generated/Raven-Demeter/api';
import useTableDefinitionsApi from '../../../Apis/Hooks/useTableDefinitionsApiHook';
import { IRegionCommoditySelection } from './useRegionCommodityNavigationHook';

const useMatchedMarket = (tableDefinitionType: DemeterTableDefinitionType, regionCommoditySelection: IRegionCommoditySelection): DemeterMarket | undefined => {
    const tableDefinitions = useTableDefinitionsApi(tableDefinitionType, false, DemeterMarket.All);

    return tableDefinitions
        ?.find((region) => region.region === regionCommoditySelection.region)
        ?.demeterTableDefinitionGroups?.find((group) => group.commodity === regionCommoditySelection.commodity)?.market;
};

export default useMatchedMarket;
